import { Dialog } from '@headlessui/react'
import { useSnapshot } from 'valtio'
import { type ReactElement } from 'react'
import { ErrorBox } from '../../../../../shared/components/ui/ErrorBox'
import { customerProxy } from '../../../../../shared/proxies/customerProxy'
import { CancelButton } from '../../../../../shared/components/ui/buttons/CancelButton'
import { SubmitButton } from '../../../../../shared/components/ui/buttons/SubmitButton'
import { handleSubmit, closeModal } from './utils'

export function CustomerDetailCardDeleteModal (): ReactElement {
  const { apiCallCustomerCardDelete, displayDeleteModal, customerCard } = useSnapshot(customerProxy)

  return (
    <Dialog
      open={displayDeleteModal}
      onClose={() => { customerProxy.displayDeleteModal = false }}
      className="fixed z-10 inset-0 overflow-y-auto"
    >
      <div className="flex items-center justify-center min-h-screen">
        <Dialog.Overlay className="fixed inset-0 bg-black opacity-30" />

        <div className="relative bg-white rounded max-w-2xl mx-auto p-5">
          <Dialog.Title>
            <div className="mb-4">
              <div className="text-xl font-medium">Delete Payment Method</div>
              <hr />
            </div>
          </Dialog.Title>

          <form className="w-[40rem]" onSubmit={handleSubmit}>

            <div className="text-center">
              Are you sure you want to this Credit Card: {customerCard?.cardName}
            </div>

            <div className="flex justify-between mt-6">
              <CancelButton onClick={closeModal} text="Cancel" />
              <SubmitButton text="Confirm" />
            </div>
          </form>
          <ErrorBox error={apiCallCustomerCardDelete.error ?? apiCallCustomerCardDelete.error} />
        </div>
      </div>
    </Dialog>
  )
}
